import React, { useEffect, useRef } from "react";
import { BOT_CONV_MESSAGE_TYPE } from "../../helpers/consts/common-consts";
import { defaultChatBotSettings } from "../../consts/settings";
import BotMessageFactory from "../question-ask/bot-message/bot-message-factory";

export default function ChatConversation(props) {
  const messageEndRef = useRef(null);
  const settings = props.chatBotSetting || defaultChatBotSettings;

  useEffect(() => {
    messageEndRef.current?.scrollIntoView?.({ block: "end" });
  }, [props.message]);

  return (
    <div ref={messageEndRef} className="chat-message">
      {props.senderType === BOT_CONV_MESSAGE_TYPE ? (
        <div className="chat-message-row">
          <div className="chat-message-avatar">
            <img src={settings.logo || defaultChatBotSettings.logo} alt="Assistant" />
          </div>
          <div className="chat-message-content"><BotMessageFactory {...props} /></div>
        </div>
      ) : (
        <div className="chat-message-row justify-end">
          <div className="chat-user-bubble" style={{ backgroundColor: settings.headerBackgroundColor, color: settings.headerTextColor }}>
            <p>{props.message}</p>
          </div>
        </div>
      )}
    </div>
  );
}
